<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7fQmt8/tc-custom/9781488068485.jpg?1708084682021" alt="This image is the cover for the book Sheikh's Royal Announcement"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sheikh's Royal Announcement
      </h1>
      <p class="bookDescription body article font2">
        <b>Nothing will keep this alpha male from his secret child in this high-stakes marriage of convenience romance from the <i>USA Today</i>–bestselling author.</b><br/><br/><i>From discovering his secret heir . . . to claiming his Cinderella bride!</i><br/><br/>When King Kadir Al Marara finds out he has a four-year-old son, nothing can keep him away! He immediately boards his private jet for a surprise reunion with the boy’s unsuspecting mother, Caitlin.<br/><br/>Shocked, Caitlin realizes she’d misjudged Kadir. Now he’s offering to transform her ordinary life to one of opulence—as his queen! As Caitlin struggles to resist the scorching chemistry still raging between them, the world awaits an extraordinary royal announcement . . . <br/><br/><b>From Harlequin Presents: Escape to exotic locations where passion knows no bounds.</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sharon Kendrick
      </h2>
      
      <p class="authorDescription body article">Sharon Kendrick started story-telling at the age of eleven and has never stopped. She likes to write fast-paced, feel-good romances with heroes who are so sexy they&rsquo;ll make your toes curl! She&#160;lives in the beautiful city of Winchester &ndash; where she can see the cathedral from her window (when standing on tip-toe!). She has two children, Celia and Patrick and her passions include music, books, cooking and eating &ndash; and drifting into daydreams while working out new plots.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4b479c80